export const BASE_URL = "https://hisobot.karantin.uz/";
// export const BASE_URL = "https://ruling-spider-usefully.ngrok-free.app/";
export const BASE_URL2 = "http://192.168.145.126:8000/";
// export const BASE_URL = "http://195.158.24.122:22280/" //tashqi
// export const BASE_URL = "http://192.168.145.126:8000/" //ichki //account
